// initial state
const state = () => ({
    currentPage: 0,
    pageSize: 0,
    result: [],
    totalPages: 0,
    totalRecords: 0,
});

// getters
const getters = {
    getNotificationsState(state) {
        return state;
    },
};

// actions
const actions = {};

// mutations
const mutations = {
    setNotificationsState(state, payload) {
        for (var [key, value] of Object.entries(payload)) {
            state[key] = value;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
